import React, { useState } from 'react';

import { Contact } from '@/types/contact';
import { useAppSelector } from '@/store';
import { billingContactsApi } from '@/services/api';
import { BillingContactForm } from '@/components/pages/Subscription/Presentation/Form/Address/BillingContactForm';
import { authStore } from '@/store/auth';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

type Props = {
  contact: Contact;
  onComplete: () => void;
  setFieldValue: {
    (
      field:
        | 'billingContactId'
        | 'contactId'
        | 'serviceIds'
        | 'adminIds'
        | 'users'
        | 'startsOn'
        | 'projectClassId',
      value: any,
      shouldValidate?: boolean | undefined,
    ): void;
    (field: string, value: any): void;
  };
};

export const BillingContactFormUpdateContainer: React.FC<Props> = ({
  contact,
  onComplete,
  setFieldValue,
}) => {
  const { apiErrorHandler } = useApiErrorHandler();
  const organizationId = useAppSelector(
    authStore.selectors.organizationIdSelector,
  );

  const [isConnecting, setIsConnecting] = useState(false);

  const onSubmit = async (contact: Contact) => {
    try {
      setIsConnecting(true);

      const item = await billingContactsApi.update({
        data: {
          contact,
          organizationId,
        },
      });

      // setIsConnecting needs to be called before history.push (for Prompt)
      setIsConnecting(false);

      setFieldValue('billingContactId', item.id);

      onComplete();
    } catch (err) {
      setIsConnecting(false);
      apiErrorHandler(err);
    }
  };

  return (
    <BillingContactForm
      contact={contact}
      isConnecting={isConnecting}
      onSubmit={onSubmit}
    />
  );
};
